<template>
  <div v-if="can_view">
    <template>
      <v-row style="width: 300px;">

        <v-col cols="10" class="pa-0 ma-0">
          <v-row class="pa-0 ma-0 pt-1">
            <p v-if="curr_status == -1" class="ma-0" style="cursor:default; font-size: 14px; color:rgba(255, 0, 0, 0.7);">Актуальные данные отсутствуют </p>
            
            <p v-else class="ma-0" style="cursor:default;  font-size: 14px;">{{ (GETTERS_KISI_STATUS.energy_s2/1000).toFixed(3) }}ГэВ {{ GETTERS_KISI_STATUS.ibeam_s2 }}мА  {{ g.ToHmsFromSeconds(GETTERS_KISI_STATUS.tau_s2) }}</p>
          </v-row>
          <v-row class="pa-0 ma-0" style="margin-top: -12px !important;">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <p style="cursor:help;  font-size: 10px;" width="100%" v-bind="attrs" v-on="on" class="ma-0">{{ GETTERS_KISI_STATUS ? g.toDateTime(GETTERS_KISI_STATUS.created_at) : '' }}</p>    
              </template>
              <span> Последнее обновление данных на сервере</span>
            </v-tooltip>
              
          </v-row>
        </v-col>
        <v-col cols="2" class="pa-0 ma-0 pt-3">
          <v-btn 
            icon x-small color="#fff" v-if="curr_status != 1"
            @click="update_kisi_status()"
            >
            <v-icon>mdi-reload</v-icon>
          </v-btn>
        </v-col>
      </v-row>


<!-- 
      <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <h2 v-bind="attrs" v-on="on" x-small style="color:rgba(255, 0, 0, 0.7);">Актуальные данные отсутствуют </h2>
            </template>
            <span> Последнее обновление данных на сервере : {{ GETTERS_KISI_STATUS ? g.toDateTime(GETTERS_KISI_STATUS.created_at) : '' }}</span>
          </v-tooltip>
          <br>
          <p>{{ GETTERS_KISI_STATUS ? g.toDateTime(GETTERS_KISI_STATUS.created_at) : '' }}</p>    

            <v-btn icon small color="#fff">
              <v-icon>mdi-reload</v-icon>
            </v-btn> -->



  </template>
    <!-- <template v-else>
      <v-tooltip right>
        <template v-slot:activator="{ on, attrs }">
          <h1 v-bind="attrs" v-on="on" v-if="GETTERS_KISI_STATUS" class="switch__current-lang"  x-snall style="color: #ffffffb3 !important; margin-top:-2.9px;">{{ (GETTERS_KISI_STATUS.energy_s2/1000).toFixed(3) }}ГэВ {{ GETTERS_KISI_STATUS.ibeam_s2 }}мА  {{ g.ToHmsFromSeconds(GETTERS_KISI_STATUS.tau_s2) }}</h1>
        </template>
        <span> {{ GETTERS_KISI_STATUS ? g.toDateTime(GETTERS_KISI_STATUS.created_at) : '' }}</span>
      </v-tooltip>      
    </template> -->
  </div>
</template>

<script>

import { mapActions, mapMutations, mapGetters } from 'vuex';

export default {
  name: 'KisiStatus',
  components: {
  },

  data() {
    return {
      can_view: false,
      curr_status: -1,
    }
  },

  beforeMount() {
    this.prepare()
  },

  watch:{
    GETTERS_KISI_STATUS(val){
      // console.log('!@!@ KISI_STATUS  @!@! ',val)
      var diff = Math.abs(new Date() - new Date(val['created_at']))

      if(diff > 3600000){  // 1 hour
        this.curr_status = -1
      }
      else if(diff > 600000){  // 10 minute
        this.curr_status = 0
      }
      else{
        this.curr_status = 1
      }

    },

    GETTERS_HAVE_ROLE(val){
      this.prepare()
    },

    GETTERS_NEED_LOAD_KISI_STATUS(val){
      if(val){
        this.MAKE_LOAD_KISI_STATUS()
      }
    },
  },

  methods: {
    ...mapActions([
      'MAKE_LOAD_KISI_STATUS',
    ]),
    ...mapMutations([
      'SET_LOAD_KISI_STATUS',
    ]),

    get_color(){
      if(this.curr_status > 0)
        return '#ffffffb3'
      else
        return '#ff0000de'
    },

    update_kisi_status(){
      console.log('update_kisi_status')
      this.prepare()
    },

    prepare(){
      this.can_view = this.GETTERS_HAVE_ROLE('kisi_user')

      if(this.can_view){
        if(!this.GETTERS_NEED_LOAD_KISI_STATUS){
          this.SET_LOAD_KISI_STATUS(true)
        }        
      }

    },
  },

  computed: {
    ...mapGetters([
      'GETTERS_KISI_STATUS',
      'GETTERS_HAVE_ROLE',
      'GETTERS_NEED_LOAD_KISI_STATUS',
    ]),
  },
};
</script>

